<template>
  <div class="wizard-footer flex-shrink-0 pt-3 pb-3 mt-2">
    <div
      v-if="hintMessage"
      class="alert alert-warning d-flex align-items-center gap-2 py-2 px-3 mb-3 fs-7"
      role="status"
    >
      <i class="ki-outline ki-information-2 text-black-50 fs-4 flex-shrink-0" aria-hidden="true" />
      <span class="text-black-50 fw-bold">{{ hintMessage }}</span>
    </div>

    <div class="d-flex align-items-stretch gap-3 w-100">
      <button
        v-if="showBack"
        type="button"
        class="btn btn-secondary flex-fill w-100"
        :disabled="backDisabled"
        @click="$emit('back')"
      >
        Назад
      </button>

      <button
        type="button"
        class="btn btn-primary flex-fill w-100"
        :disabled="primaryAction.disabled"
        @click="$emit('primary')"
      >
        <i v-if="primaryAction.loading" class="fa-solid fa-spinner fa-spin" style="width: 13px;height: 13px;"></i>
        <template v-if="primaryAction.loading">&nbsp;</template>
        {{ primaryAction.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WizardFooter',
  props: {
    hintMessage: {
      type: String,
      default: null,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    backDisabled: {
      type: Boolean,
      default: false,
    },
    primaryAction: {
      type: Object,
      required: true,
      validator(action) {
        return action && typeof action.label === 'string'
          && typeof action.disabled === 'boolean'
      },
    },
  },
  emits: ['back', 'primary'],
}
</script>

<style scoped>
@media (min-width: 768px) {
  .wizard-footer {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}
</style>
